import React from "react";
import { Link } from "react-router-dom";
import { Home, Mail } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#1A2421] text-[#EADCC8] mt-24">
    <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-[#C86650] flex items-center justify-center">
            <Home className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="font-serif text-lg text-white">Saddleridge · Savoy Chase · The Trails HOA, Inc.</p>
          </div>
        </div>
        <p className="text-sm text-[#B5AC9A] max-w-md leading-relaxed">
          A community-owned association serving homeowners across three neighborhoods —
          keeping our streets, amenities, and shared spaces well-cared-for.
        </p>
      </div>
      <div>
        <p className="font-serif text-lg text-white mb-4">Quick Links</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/announcements" className="hover:text-white">Announcements</Link></li>
          <li><Link to="/amenities" className="hover:text-white">Amenities</Link></li>
          <li><Link to="/documents" className="hover:text-white">Documents</Link></li>
          <li><Link to="/get-involved" className="hover:text-white">Get Involved</Link></li>
          <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
        </ul>
      </div>
      <div>
        <p className="font-serif text-lg text-white mb-4">Contact</p>
        <ul className="space-y-2 text-sm">
          <li className="flex items-center gap-2"><Mail className="w-4 h-4" />saddleridgesavoytrailshoa@gmail.com</li>
          <li className="text-[#B5AC9A]">3983 E. Saddleridge Dr.<br />Stonecrest, GA</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[#2A342F]">
      <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-[#8C8474] flex flex-wrap justify-between gap-3">
        <span>© {new Date().getFullYear()} Saddleridge / Savoy Chase / The Trails HOA, Inc. All rights reserved.</span>
        <span>Powered by community stewardship.</span>
      </div>
    </div>
  </footer>
);
